import Nav from '@/components/nav';
import { Toaster } from '@/components/ui/sonner';
import { SharedData } from '@/types';
import { usePage } from '@inertiajs/react';
import { type ReactNode } from 'react';

interface AppLayoutProps {
    fullWidth?: boolean;
    children: ReactNode;
}

export default function AppLayout({ fullWidth = false, children }: AppLayoutProps) {
    const { auth } = usePage<SharedData>().props;

    return (
        <div className="absolute flex min-h-screen min-w-full flex-col bg-[url('@/../images/mobi_back.webp')] bg-cover bg-fixed bg-center">
            <div className="bg-background/86 dark:bg-background/94 grow dark:backdrop-grayscale">
                {auth?.user && <Nav />}
                <div className={fullWidth ? 'w-full' : 'm-2.5 mx-auto w-[1000px]'}>{children}</div>
            </div>
            <Toaster richColors />
        </div>
    );
}
